import type { UseMutationOptions } from '@tanstack/react-query';
import { mutationOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import { getCheckoutAttributionHeaders } from '@/utils/attribution';

import type { UpsertCartResponse } from '../upsertCartMutation';
import type { CheckoutCartPayload } from './types';

async function checkoutCart(
  shopId: string,
  cartId: string,
  payload: CheckoutCartPayload,
) {
  const { data } = await apiClient.post<UpsertCartResponse>(
    `/v2/shop/${shopId}/cart/${cartId}/checkout`,
    payload,
    { timeout: 0, headers: getCheckoutAttributionHeaders() },
  );

  return data;
}

export const checkoutCartMutation = (
  shopId: string,
  cartId: string,
  options?: UseMutationOptions<UpsertCartResponse, Error, CheckoutCartPayload>,
) =>
  mutationOptions({
    ...options,
    retry: false,
    mutationKey: ['checkoutCart', shopId, cartId],
    mutationFn: (data: CheckoutCartPayload) =>
      checkoutCart(shopId, cartId, data),
  });
